





































import { mapActions, mapGetters } from 'vuex'
import Logo from '@/components/atoms/Logo/Logo.vue'
import XForm from '@/components/atoms/Form/XForm.vue'
import XButton from '@/components/atoms/Button/XButton.vue'
import XInput from '@/components/atoms/Input/XInput.vue'
import { ForgotPasswordInput } from '@/types/generated/graphql'
import toastMixin from '@/mixin/toastMixin'

export default toastMixin.extend({
  components: { Logo, XForm, XButton, XInput },
  data(): { input: ForgotPasswordInput } {
    return {
      input: {
        email: '',
      },
    }
  },
  computed: {
    ...mapGetters('loading', ['isLoading']),
  },
  methods: {
    ...mapActions('auth', ['forgotPassword']),
    async handleSend() {
      await this.forgotPassword(this.input)
      this.showToast(this.$tc('forgotpassword.sendSuccess'))
    },
  },
})
